// extracted by mini-css-extract-plugin
var _1 = "CalendarTasksView-moduleskeleton__jVNvF Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
